@app.directive 'bannerPremiumClass', (PricingService, AnalyticsService) ->
  restrict: 'E'
  scope: {}
  controllerAs: 'bannerPremiumClass'
  replace: true
  controller: ->

    @trackMoreInfo = ->
      AnalyticsService.track 'Banner Clicked', {name: 'bannerPremiumClass'}

    @price = PricingService.getPrice(PricingService.PREMIUM_SKU, {userIsPremium: false, usedCirculatorDiscount: false}).price

    this

  link: (scope, element, attrs) ->

  bindToController: {
    theme: '='
    content: '='
  }
  templateUrl: "/assets/templates/components/banner/bannerPremiumClass/bannerPremiumClass.html"
